import { useEffect, useState, ReactElement } from "react";
import { AppShell, Box, Container, Loader, Center, Text, Title, Divider } from "@mantine/core";
import { Header } from "../components/layout/Header";
import { useMantineColorScheme } from "@mantine/core";

const renderMarkdown = (markdown: string, isDark: boolean): ReactElement[] => {
  const borderColor = isDark ? "var(--mantine-color-dark-4)" : "var(--mantine-color-gray-3)";
  const lines = markdown.split("\n");
  const elements: ReactElement[] = [];
  let key = 0;

  for (const line of lines) {
    if (line.startsWith("# ")) {
      elements.push(<Title key={key++} order={1} mb="lg">{line.slice(2)}</Title>);
    } else if (line.startsWith("## ")) {
      elements.push(
        <Box key={key++} mt="xl" mb="sm" style={{ borderBottom: `1px solid ${borderColor}`, paddingBottom: 6 }}>
          <Title order={2}>{line.slice(3)}</Title>
        </Box>
      );
    } else if (line.startsWith("### ")) {
      elements.push(<Title key={key++} order={4} mt="md" mb="xs">{line.slice(4)}</Title>);
    } else if (line.startsWith("- ")) {
      // Handle **bold** inside list items
      const text = line.slice(2).replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
      elements.push(
        <Text key={key++} component="li" mb={4} ml="md"
          dangerouslySetInnerHTML={{ __html: text }} />
      );
    } else if (line.trim() === "---") {
      elements.push(<Divider key={key++} my="md" />);
    } else if (line.trim() !== "") {
      const text = line.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
      elements.push(<Text key={key++} mb="xs" dangerouslySetInnerHTML={{ __html: text }} />);
    }
  }

  return elements;
};

export const ChangelogPage = () => {
  const [content, setContent] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  useEffect(() => {
    fetch("/changelog/users-changelog.md")
      .then((res) => {
        if (!res.ok) throw new Error("Not found");
        return res.text();
      })
      .then(setContent)
      .catch(() => setError(true));
  }, []);

  return (
    <AppShell header={{ height: 60 }} padding="md">
      <AppShell.Header>
        <Header />
      </AppShell.Header>
      <AppShell.Main>
        <Container size="md" py="xl">
          {!content && !error && (
            <Center>
              <Loader />
            </Center>
          )}
          {error && (
            <Center>
              <Text c="red">Could not load changelog.</Text>
            </Center>
          )}
          {content && (
            <Box style={{ lineHeight: 1.75 }}>
              {renderMarkdown(content, isDark)}
            </Box>
          )}
        </Container>
      </AppShell.Main>
    </AppShell>
  );
};
